// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fvJk","content":"styles_content__1xzFt","row":"styles_row__rylqO","footer":"styles_footer__1_aIr","phraseLength":"styles_phraseLength__2f-Xq"};